import { LinkedIn, LocationOn, MailOutline, Phone, GitHub } from "@material-ui/icons";
import "./resume.css";
import {useEffect, useState } from 'react';
import { HTTP } from "../../api/http-common";
import { HTMLDescription } from '../projects/HTMLDescription';


function Resume() {
  const [data, setData] = useState(null);

  useEffect(() => {
  
    let url = '/api/portfolio/cv/'
    HTTP.get(url)
    .then(function (response) {
        if(response.status === 200)
        {
          let data = response.data
          console.log(data)
          if (data)
          {
            setData(data)              
          }
          
        }
    })
    .catch(function (err) {
        console.log(err);
    });
    

  }, []); 
  

  const education = [
    {
      id: 1,
      degree: "MCA",
      collageName: "Indus University Ahmedabad, Gujarat",
      year: 2022,
      percentage: "8.14 CGPA",
    },
    {
      id: 2,
      degree: "BCA",
      collageName: "Indus University Ahmedabad, Gujarat",
      year: 2020,
      percentage: "6.04 CGPA",
    },
    {
      id: 3,
      degree: "12th Class",
      collageName: "R.U.Inter College (U.P.)",
      year: 2016,
      percentage: "68.20 %",
    },
    {
      id: 4,
      degree: "10th Class",
      collageName: "S.A.K.J. Intermediate College (U.P.)",
      year: 2014,
      percentage: "80.50 %",
    },
  ];

  const project = [
    {
      id: 1,
      title: "Student Management System (PHP, Mysql)",
      description:
        "Student Management System (PHP, Mysql) The project is based on\
      Student Management system. It helps to check Admin Panel\
      everything about students and maintain and also Student can see\
      their details by entering roll no.",
    },
    {
      id: 2,
      title: "Game (HTML, CSS, Javascript)",
      description:
        "This is an animation based Game, in this Game have two Animals\
      Cat and Dog that Cat is jump to save from Dog.",
    },
    {
      id: 3,
      title: "Gym Management System (Python, Django)",
      description:
        "The Project is a software designed to help the gym to keep the\
      track of the day to day activities which take place in the gym.\
      Project deals with an online system designed for management of\
      customers,enquiries, and equipments, payment etc.",
    },
    {
      id: 4,
      title: "Note Taker (Java Servlet,JSP,Hibernate)",
      description:
        "This project is documentation based that Can store Information\
      and perform CRUD operations.",
    },
    {
      id: 5,
      title: "Tip Calculator (HTML,CSS,Javascript)",
      description:
        "The project is based on Calculate the Tip for each Employees.",
    },
  ];

  const certificate = [
    {
      id: 1,
      title: "Building Web Applications with PHP (12/2020)",
      academy: "University of Michigan(Coursera)",
    },
    {
      id: 2,
      title: "Python Programming ( 11/2020)",
      academy: "Great Learning Academy",
    },
    {
      id: 3,
      title:
        "Gujcost Sponsored National Level Five Days STTP on AI and ML\
      Applications in Data Science",
      academy: "Indus University",
    },
    {
      id: 4,
      title: "DevOpsWorkshop",
      academy: "Agile Group of Companies",
    },
  ];

  const contact_details = {
    id: 3,
    address: 
    "D-104 Falak heights opp Safal-8 Rakhial Ahmedabad, Gujarat -380023",
    description: 
    "I see myself as ambitious, self made and diligent person who believes in teamwork and has a good learning attitude with an aspiration to forge ahead of competition.",
    designation: "Sr. Software Engineer",
    email: "nafeesofficial@gmail.com",
    github_url: "https://github.com/uniquedeveloper143", 
    image: "assets/images/Mohd Nafees Image2.png",
    linked_url: 
    "https://www.linkedin.com/in/786-92-nafees/",
    phone: "+91 7490078839",
    working_hours: null,
  }

  const experience = [
      {
          "id": 1,
          "company_name": "Hyperlink Infosystem Ahmedabad, Gujarat",
          "role": "Full Stack Software Engireer",
          "start": "Jan-2022",
          "end": "Aug-2023",
          "description": "Software development in Django Framework. API development in Django Rest Framework."
      },
      {
          "id": 2,
          "company_name": "Savitriya Technologies Private Limited",
          "role": "Sr. Full Stack Software Engireer",
          "start": "Sep-2023",
          "end": "Jul-2024",
          "description": "Software development in Django Framework. API development in Django Rest Framework."
      },
      {
        "id": 3,
        "company_name": "NeoSOFT Technologies Private Limited",
        "role": "AI/ML Engineer | Sr. Full Stack Software Engineer",
        "start": "Jul-2024",
        "end": "Present",
        "description": "Software development in Django Framework. API development in Django Rest Framework."
    }
  ]


  return (
    <div
      className="bg-move-resume" style={{ marginTop: "60px" }}
      // style={{
      //   backgroundImage: `url("assets/images/n1.jpg")`,
      // }}
    >      <p className="text-center contText">Resume</p>

      <div className="mainTop mb-5 mt-5">
        <div className="row resumeTopRow">
          <div className="col-12 col-lg-4 col-md-6 resumeTopCol" id="">
            <span className="nameText "> 
              {data?.contact_details ? data.contact_details[0].designation : contact_details.designation} 
              </span>
            <br />
            <br />
            <p className="resumeText text-left">
            {
            data?.contact_details ? 
            <HTMLDescription description={data.contact_details[0].description } />
            : 
            contact_details.description
            }
            </p>
          </div>

          <div className="col-12 col-lg-4 col-md-6 resumeBottomCol" id="">
            <p className="">
              {" "}
              <MailOutline /> {data?.contact_details ? data.contact_details[0].email : contact_details.email}
            </p>
            <p>
              <Phone /> {data?.contact_details ? data.contact_details[0].phone : contact_details.phone}
            </p>
            <p>
              <LinkedIn /> {data?.contact_details ? data.contact_details[0].linked_url : contact_details.linked_url}
            </p>
            <p>
              <GitHub /> {data?.contact_details ? data.contact_details[0].github_url : contact_details.github_url}
            </p>
            <p>
              <LocationOn /> {data?.contact_details ? data.contact_details[0].address : contact_details.address}
            </p>
          </div>

          <div className="col-12 col-lg-4 col-md-12 resumeMiddleCol" id="">
            <div className="imgDiv">
              <img src={data?.contact_details ? data.contact_details[0].image : contact_details.image} alt="" className="resumeImg" />
            </div>
          </div>
        </div>
      </div>

      <div className="row educationRow">
        <div className="col-12 col-lg-6 col-md-6">

          {/* Education card */}
          <div className="education">
            <span className="educationListText">EDUCATIONS</span>

            {
              data?.education ? 

              data.education.map((data) => {
                  return (
                    <div key={data.id} className="educationList mb-2 mt-2">
                      <span className="degree">{data.name}</span>
                      <p className="collageText">{data.college_name}</p>
                      <p className="percentage">
                        {" "}
                        {data.end} <div className="year"></div> {data.percentage}
                      </p>
                    </div>
                  );
                })
              
              :

                education.map((data) => {
                  return (
                    <div key={data.id} className="educationList mb-2 mt-2">
                      <span className="degree">{data.degree}</span>
                      <p className="collageText">{data.collageName}</p>
                      <p className="percentage">
                        {" "}
                        {data.year} <div className="year"></div> {data.percentage}
                      </p>
                    </div>
                  );
                })
            
            }
          </div>

          {/* EXPERIENCE card */}
          <div className="education mt-3">
            <span className="educationListText">EXPERIENCE</span>

            {   
              data?.experience ? 

              data.experience.map((data) => {
                return (
                <div key={data.id} className="educationList mb-2 mt-2">
                  <span className="degree">{data.role}</span>
                  <p className="collageText">
                    {data.company_name}
                  </p>
                  <p className="percentage">
                  {data.start} <div className="year">--</div> {data.end}
                  </p>
                  <p className="mt-1 projectText">
                    <div className="row">
                      <div className="col-12 text-left px-4">
                        <HTMLDescription description={data.description} />
                      </div>
                    </div>
                  </p>
                </div>

              );
              })

            :
            
              experience.map((data) => {
                return (
                <div key={data.id} className="educationList mb-2 mt-2">
                  <span className="degree">{data.role}</span>
                  <p className="collageText">
                    {data.company_name}
                  </p>
                  <p className="percentage">
                  {data.start} <div className="year">--</div> {data.end}
                  </p>
                  <p className="mt-2 projectText">
                    <div className="row">
                      <div className="col-2"></div>
                      <div className="col-10 text-left">
                        {data.description}
                        
                      </div>
                    </div>
                  </p>
                </div>

              );
              })

            }

          </div>

          {/* SKIILS card */}
          <div className="education mt-3">
            <span className="educationListText">SKIILS</span>

            <div className="educationList mb-2 mt-2">
              <span className="degree">Tech Languages</span>
              <br />
              <p>
              {   
              data?.technology ? 

              data.technology.map((data) => {
                return (

                  <span key={data.id} className="techLan">{data.name}</span>
                    
                  );
                  })
                :
                <>
                <span className="techLan">Python</span>
                <span className="techLan">Django</span>
                <span className="techLan">Django Rest Framework</span>
                <span className="techLan">PHP</span>
                <span className="techLan">Java</span>
                <span className="techLan">HTML</span>
                <span className="techLan">CSS</span>
                <span className="techLan">Bootstrap</span>
                <span className="techLan">Javascript</span>
                <span className="techLan">JQuery</span>
                <span className="techLan">React JS</span>
                <span className="techLan">Material UI</span>
                </>
                }
              </p>
            </div>

            <div className="educationList mb-2">
              <span className="degree">Languages</span>
              <br />
              <p>
              {   
                data?.language ? 

                data.language.map((data) => {
                  return (

                    <span key={data.id} className="techLan">{data.name}</span>
                      
                    );
                    })
                  :
                  <>
                    <span className="techLan">Hndi</span>
                    <span className="techLan">English</span>
                    <span className="techLan">Gujarati</span>
                    <span className="techLan">Urdu</span>
                  </>
                }
              </p>
            </div>
          </div>

          {/* CERTIFICATES card */}
          <div className="education mt-3">
            <span className="educationListText">CERTIFICATES</span>

            {

              data?.certificate ? 

                data.certificate.map((data) => {
                  return (
                    <div key={data.id} className="educationList mb-2 mt-2">
                      <span className="degree">{data.title}</span>
                      <p className="percentage">{data.provider}</p>
                    </div>
                  );
                })
                :
                certificate.map((data) => {
                  return (
                    <div key={data.id} className="educationList mb-2 mt-2">
                      <span className="degree">{data.title}</span>
                      <p className="percentage">{data.academy}</p>
                    </div>
                  );
                })
            
            }

          </div>

          {/* INTERESTS card */}
          <div className="education mt-3">
            <span className="educationListText">INTERESTS</span>

            <div className="educationList mt-2">
              <p>
              {   
                data?.hobby ? 

                data.hobby.map((data) => {
                  return (

                    <span key={data.id} className="techLan">{data.name}</span>
                      
                    );
                    })
                  :
                  <>
                    <span className="techLan">Reading</span>
                    <span className="techLan">Coding</span>
                    <span className="techLan">Traveling</span>
                    <span className="techLan">Sports</span>
                    <span className="techLan">Research and Development</span>
                  </>
                }
              </p>
            </div>
          </div>

          {/* STRENGTHS card */}
          <div className="education mt-3">
            <span className="educationListText">STRENGTHS</span>

            <div className="educationList mt-2">
              <p>
              {   
                data?.strength ? 

                data.strength.map((data) => {
                  return (

                    <span key={data.id} className="techLan">{data.name}</span>
                      
                    );
                    })
                  :
                  <>
                    <span className="techLan">Self motivated</span>
                    <span className="techLan">Time punctual</span>
                    <span className="techLan">Hard working</span>
                    <span className="techLan">Quick learning ability</span>
                    <span className="techLan">Problem solving skills</span>
                  </>
                }
              </p>
            </div>
          </div>
          
        </div>


        <div className="col-12 col-lg-6 col-md-6">

          {/* Project card */}
          <div className="education">
            <span className="educationListText">PROJECTS</span>
            { 
              data?.project ? 
              
              data.project.map((data) => {
                return (
                  <div key={data.id} className="educationList mb-3 mt-2 p-2">
                    <span className="degree projectTitle">{data.title}</span>
                    {/* <p className="mt-2 projectText">{data.description}</p> */}
                    <HTMLDescription description={data.description} />


                    {/* Skills */}
                    {
                      data.skill ?
                      <>
                      <div className="mt-3 text-left">
                      <strong>Skills:</strong>{" "}
                      <span className="text-muted">
                        {data.skill}
                      </span>
                      </div>
                      </>
                      :
                      ""
                    }

                    {/* Duration */}
                    {(data.start || data.end) && (
                      <div className="mt-0 text-left">
                        <strong>Duration:</strong>{" "}
                        <span className="text-muted">{data.start} Year(s) {data.end} Month(s)</span>
                      </div>
                    )}

                    {/* Team Size */}
                    { data.team_size > 1 &&
                      <div className="mt-0 text-left">
                        <strong>Team Size :</strong>{" "}
                        <span className="text-muted">{data.team_size}</span>
                      </div>
                    }
                  </div>
                );
              })

              :

              project.map((data) => {
                return (
                  <div key={data.id} className="educationList mb-2 mt-2 p-2">
                    <span className="degree projectTitle">{data.title}</span>
                    <p className="mt-2 projectText">{data.description}</p>
                  </div>
                );
              })
            
            }
          </div>

        </div>
      </div>
    </div>
  );
}

export default Resume;
